<script>
import { DEFAULT_THANK_YOU_PAGE_MESSAGE } from '@/constants/donationConfirmation.js'
import { renderThankYouPageMessage } from '@/helpers/donationConfirmation.js'

export default {
  name: 'DonationThankYouMessage',
  props: {
    message: {
      type: String,
      default: null
    },
    donation: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayMessage() {
      return renderThankYouPageMessage(this.message, this.donation) || DEFAULT_THANK_YOU_PAGE_MESSAGE
    }
  }
}
</script>

<template>
  <div class="text-center mb-8 flex flex-col gap-3">
    <h1>Thank you!</h1>
    <!-- displayMessage is sanitized with DOMPurify before rendering. -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="thank-you-message break-words" v-html="displayMessage" />
  </div>
</template>

<style scoped>
.thank-you-message :deep(p + p) {
  margin-top: 1em;
}

.thank-you-message :deep(ul),
.thank-you-message :deep(ol) {
  margin: 1em 0;
  padding-left: 1.5em;
  text-align: left;
}

.thank-you-message :deep(ul) {
  list-style-type: disc;
}

.thank-you-message :deep(ol) {
  list-style-type: decimal;
}

.thank-you-message :deep(a) {
  text-decoration: underline;
}

.thank-you-message :deep(blockquote) {
  border-left: 4px solid #ccc;
  margin: 1em 0;
  padding-left: 1em;
}

.thank-you-message :deep(pre) {
  background: #f3f4f6;
  padding: 1em;
  text-align: left;
  white-space: pre-wrap;
}
</style>
